import { AddClickOutsideListener, RemoveClickOutsideListener } from "./click-outside";
import { AddClickTraceHandler } from "./click-trace";
import { SetDDEscFunc } from "./escape-handlers";

let CurDD:{dd: HTMLElement,btn: HTMLButtonElement };
SetDDEscFunc(function() {
    if(!CurDD) return false;
    HideDropdown();
    return true;});


let ddObserver = new IntersectionObserver(entries=>{
    for(var entry of entries) {
        let cnt= entry.target.parentElement.getBoundingClientRect(); 
        let cr= entry.target.getBoundingClientRect();
        if(entry.isIntersecting) continue; // menu er helt inde i viewport - fint!
        // ikke helt ind i viewport
        if((<any>entry.target).__ddUnder) {
            // menu er under
            if(cr.height>cnt.top) continue; // der er ikke plads over - bliv under!
            // der er plads til den over - flyt til over:
            (<HTMLElement>entry.target).style.bottom=cnt.height + "px";
            (<any>entry.target).__ddUnder=false;
        } else {
            if(cr.bottom>document.documentElement.clientHeight) continue; // der er ikke plads under - bliv over!
            // menu er over - ikke helt inde i viewport - flyt til under:
            (<HTMLElement>entry.target).style.bottom="unset";
            (<any>entry.target).__ddUnder=true;
        }
    }
}, { threshold: 1.0 });
    
export function ToggleDropdown(btnEl:HTMLButtonElement|string,ddEl:HTMLElement|string):void {
    if (typeof btnEl === 'string') btnEl = document.querySelector(btnEl) as HTMLButtonElement;
    if (typeof ddEl === 'string') ddEl = document.querySelector(ddEl) as HTMLElement;
    if(CurDD) {
        let IWasOpen=CurDD.btn===btnEl && CurDD.dd===ddEl;
        HideDropdown();
        if(IWasOpen) return;
    } 
    CurDD={ dd: ddEl, btn: btnEl };
    ddEl.style.bottom="unset";
    (<any>ddEl).__ddUnder=true;
    ddEl.classList.add('show');
    btnEl.classList.add('checked');
    AddClickOutsideListener(btnEl,HideDropdown);
    ddObserver.observe(ddEl);
}



/** 
 * @deprecated use data-toggle instead
 */
export function ToggleNextDropdown(btnEl:HTMLButtonElement):void {
    let el:HTMLElement=btnEl;
    while(el) {
    if(el.classList.contains('dropdown')) {
            ToggleDropdown(btnEl,el);
            return;
    }
      el=el.nextElementSibling as HTMLElement;
    }
    throw new Error("No .dropdown element found");
}

function HideDropdown():void {
    if(!CurDD) return;
    CurDD.dd.classList.remove('show');
    ddObserver.unobserve(CurDD.dd);
    CurDD.btn.classList.remove('checked');
    RemoveClickOutsideListener(CurDD.btn,HideDropdown);
    CurDD = null;
}

AddClickTraceHandler((el:HTMLElement,evt:Event)=>el.dataset.toggle==="dropdown",
   (el:HTMLElement,evt:Event)=> ToggleDropdown(<HTMLButtonElement>el, el.parentNode.querySelector('.dropdown') as HTMLElement));
  
